import { requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { useContactManagementTranslation, useUserState } from '../../../../../ui/hooks';
import { useDataTreeUsingState } from '@juvare/common-data-table-ui/DataTree';
import { FiltersBar, useFilterConfig } from '@juvare/common-data-table-ui/FiltersBar';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColorsDark } from '@juvare/common-web-ui/JuvareTheme/colors/themeColorsDark';
import { LayoutRows3 } from '@juvare/common-web-ui/LayoutRows3';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import { useOrganizationSelectionTree } from '../../hooks/useOrganizationSelectionTree';
import { OrganizationTreeWithDetails } from '../OrganizationTreeWithDetails';
export function showOrganizationTreeDialog(params) {
    showCustomDialog({
        fullScreen: true,
        content: (close, ariaLabelledBy, ariaDescribedBy) => (React.createElement(OrganizationsTreeDialogContent, Object.assign({}, params, { close: close, ariaLabelledById: ariaLabelledBy, ariaDescribedById: ariaDescribedBy }))),
    });
}
const OrganizationsTreeDialogContent = (props) => {
    var _a;
    const { t } = useContactManagementTranslation();
    const userState = useUserState();
    const staticDialogFilters = React.useMemo(() => {
        if (userState && requireAnySystemPermission(userState, 'view-invisible-organizations', 'all-organizations-admin')) {
            return undefined;
        }
        return Object.assign({}, props.staticFilters);
    }, [userState, props.staticFilters]);
    const { dataTreeProps, filtersBarProps, activeOrganizationId, selectedOrganizationIds, orgTree } = useOrganizationSelectionTree({
        useDataTreeFunction: useDataTreeUsingState,
        initialSelectedOrganizationIds: props.initialSelectedOrganizationIds,
        includeRootDirectory: props.showRootDirectory,
        staticFilters: staticDialogFilters,
    });
    const filterConfig = useFilterConfig((builder) => {
        builder.quickSearchFilter({
            sx: { maxWidth: { xs: 340 } },
            label: t('common.search'),
            dataPath: 'search',
            dataTest: 'search-filter',
        });
    }, [t]);
    const disableSelectButton = props.multiSelect ? !(selectedOrganizationIds === null || selectedOrganizationIds === void 0 ? void 0 : selectedOrganizationIds.length) : !activeOrganizationId;
    return (React.createElement(LayoutRows3, { row1: React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    alignItems: 'center',
                    backgroundColor: themeColorsDark.background,
                    color: themeColorsDark.text.bold,
                    display: 'flex',
                    justifyContent: 'space-between',
                    px: 5,
                    py: 2,
                } },
                React.createElement(Typography, { id: props.ariaLabelledById, variant: 'h6' }, t(props.multiSelect ? 'panels.organizations.selectOrgs' : 'panels.organizations.selectOrg')),
                React.createElement(Button, { variant: 'text', color: 'inherit', size: 'large', onClick: () => props.close(), sx: { p: 0 }, "data-test": 'cancel-button' }, t('common.cancel')))), row2: React.createElement(OrganizationTreeWithDetails, { dataTreeProps: dataTreeProps, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })), activeOrganizationId: activeOrganizationId, multiSelect: props.multiSelect }), row3: React.createElement(React.Fragment, null,
            React.createElement(Box, { sx: {
                    borderTop: '1px solid ',
                    borderColor: (theme) => theme.palette.divider,
                    display: 'flex',
                    justifyContent: 'flex-end',
                    p: '16px 32px',
                } },
                React.createElement(Button, { disabled: disableSelectButton, variant: 'contained', color: 'primary', onClick: () => props.close(() => {
                        let value;
                        if (props.multiSelect) {
                            value = selectedOrganizationIds;
                        }
                        else if (activeOrganizationId) {
                            value = [activeOrganizationId];
                        }
                        else {
                            value = [];
                        }
                        props.onChange(value !== null && value !== void 0 ? value : [], orgTree);
                    }), "data-test": 'organization-select-button' }, (_a = props.selectButtonLabel) !== null && _a !== void 0 ? _a : t('common.select')))), fullHeightRow: 'row2' }));
};
